import StorageItem from './Models/StorageItem';

class BaseService {
    constructor() {
        
    }

    /**
     * Gets from LocalStorage
     * @param {String} key
     * @returns {*}
     */
    getFromLocalStorage(key = '', parseTo = false) {
        const value = localStorage.getItem(key);

        switch (parseTo) {
            case 'bool':
                return value === 'true';

            default:
                return value;
        }
    }

    /**
     * Saves on LocalStorage
     * @param {string} key 
     * @param {string} value 
     */
    saveOnLocalStorage(key = '', value) {
        localStorage.setItem(key, value);
    }

    /**
     * Gets Storage
     * @returns {Object}
     */
    getStorage() {
        const { useStorageStore } = require('@/stores/storage');
        return useStorageStore();
    }

    /**
     * Safely gets an array from storage
     * @param {String} key 
     * @returns {Array}
     */
    getArrayOnStorage(key = null) {
        const storageItem = this.getStorage().get(key);

        return storageItem && Array.isArray(storageItem.getValue()) 
            ? storageItem.getValue() 
            : [];
    }

    /**
     * Safely saves an array from storage
     * @param {String} key 
     * @returns {Boolean}
     */
    saveArrayOnStorage(key = '', arrayValue) {
        const arrayToSave = Array.isArray(arrayValue) ? arrayValue : [];

        if (key) {
            const storageItem = new StorageItem(key, arrayToSave);
            this.getStorage().save(key, storageItem);
            
            return true
        }

        return false;
    }
}

export default BaseService;